import React, { useState, useEffect } from 'react';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link } from '@material-ui/core';
import { ChargebacksService } from '../../../services/ChargebacksService';
import { dateToLocal, formatMoney, handleError, handleErrorToast } from '../../shared/Functions';
import { OperatorsVService } from '../../../services/V2/padre';
import { getChargebacksBatch } from '../../shared/ExportFunctions';
import CancelIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@material-ui/icons/Info';
import '../../../scss/UVP.scss';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import { authProvider } from '../../../services/Security';
import { CustomTable } from '../../shared/CustomTable';
import { ConfirmModal } from '../../shared/ConfirmModal';

export const UVPReturnsBatch = ({errorToast, successToast, selectedBatch, setSelectedTab}) => {
    const [transactions, setTransactions] = useState<any>();
    const [operator, setOperator] = useState<any>();
    const [disablePayments, setDisablePayments] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(true);
    const [hasBeenCanceled, setHasBeenCanceled] = useState<boolean>(false);
    const [hasBeenCanceledByUser, setHasBeenCanceledByUser] = useState<string | null>(null);
    const [connection, setConnection] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [showCancelBatch, setShowCancelBatch] = useState<boolean>(false);
    const [showCancelPayment, setShowCancelPayment] = useState<any | null>(null);
    const [showCancelLastPayment, setShowCancelLastPayment] = useState<any | null>(null);
    const [showRunBatch, setShowRunBatch] = useState<boolean>(false);
    const [downloading, setDownloading] = useState<boolean>(false);

    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${process.env.CHARON_HOST}/hub/Chargebacks`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets
              })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (connection && operator) {
            connection.start()
                .then(result => {
                    connection.on('ChargebackMessage', message => {
                        var username = authProvider.getUser().Username
                        var data = message
                        if(data.operatorId !== operator.id) return;
                        if(!data) errorToast("Something Failed")
                        else if(!data.id) errorToast(data)
                        else if(data.id === transactions.id && data.status === "Canceled") {
                            if(data.modified.toLowerCase().includes("rocketpack")) {
                                setHasBeenCanceled(true)
                            } else if(!data.modified.toLowerCase().includes(username.toLowerCase())) {
                                setHasBeenCanceledByUser(data.modified)
                            }
                            setTransactions(data)
                        }
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection, operator]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        ChargebacksService.chargebacksVGetBatch(selectedBatch.id)
            .then((x: any) => {
                var username = authProvider.getUser().Username
                if(x.status === "Canceled" && (x.modified.toLowerCase().includes("rocketpack"))) {
                    setHasBeenCanceled(true)
                } else if(x.status === "Canceled" && !x.modified.toLowerCase().includes(username.toLowerCase())) {
                    setHasBeenCanceledByUser(x.modified)
                }
                setTransactions(x)
                setDisablePayments(x.status === "Canceled" || x.runDate)
                OperatorsVService.operatorsVGetById(x?.operatorId)
                    .then((x) => {
                        setOperator(x)
                    }).catch(x => {
                        errorToast(handleErrorToast(x))
                    })
            }).catch(x => {
                errorToast(handleErrorToast(x))
            })
    }, [selectedBatch])// eslint-disable-line react-hooks/exhaustive-deps

    const handleDownload = () => {
        setDownloading(true)
        getChargebacksBatch(selectedBatch.id, (new Date()).toLocaleString())
            .then(x => {setDownloading(false)})
            .catch(err => {
                handleError(err)
                setDownloading(false)
            })
    }

    const removeFromBatch = () => {
        setShowCancelPayment(null)
        let list = [
            {
                chargebackId: showCancelPayment.id,
                isCanceled: true
            }
        ]

        setLoading(true)
        ChargebacksService.chargebacksVUpdateBatch(selectedBatch.id, list)
            .then((x:any) => {
                successToast("Removed")
                setRefresh(true)
                ChargebacksService.chargebacksVGetBatch(selectedBatch.id)
                .then((x: any) => {
                    setTransactions(x)
                    setLoading(false)
                }).catch(x => {
                    errorToast(handleErrorToast(x))
                    setLoading(false)
                })
            })
            .catch(err => {
                handleError(err)
                setRefresh(true)
                setLoading(false)
            })
    }

    const handleRun = () => {
        setShowRunBatch(false)
        setDisablePayments(true)
        setLoading(true)
        ChargebacksService.chargebacksVPostAutoPay(transactions.id)
            .then(x => {
                successToast(`Running. You can leave this page and come back later or refresh this page for results.`);
                setDisablePayments(true);
                setSelectedTab(0)
                setLoading(false)
            })
            .catch(x => {
                errorToast(handleErrorToast(x))
                setLoading(false)
            })
    }

    const cancelBatch = async () =>{
        setShowCancelBatch(false)
        setLoading(true)
        await ChargebacksService.chargebacksVCancelBatch(selectedBatch.id);
        successToast("Batch canceled.")
        setLoading(false)
        setSelectedTab(0)
    }

    const checkLastPayment = (rowData) =>{
        if(transactions.count === 1) {
            setShowCancelLastPayment(rowData)
        }
        else {
            setShowCancelPayment(rowData)
        }
    }

    if(!transactions) return null;

    return (
        <React.Fragment>
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setShowCancelBatch(false)}
                show={showCancelBatch}
                confirmCallback={() => cancelBatch()}
                title={"Cancel Batch"}
                description={`Are you sure you want to cancel Batch ${transactions?.batchId}?`} />
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setShowRunBatch(false)}
                show={showRunBatch}
                confirmCallback={() => handleRun()}
                title={"Run Batch"}
                description={`Are you sure you want to post Chargebacks for Batch ${transactions?.batchId}?`} />
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setShowCancelPayment(null)}
                show={showCancelPayment}
                confirmCallback={() => removeFromBatch()}
                title={"Cancel Record"}
                description={`Are you sure you want to cancel this record?`} />
            <ConfirmModal
                fullWidth={true}
                cancelCallback={() => setShowCancelLastPayment(null)}
                show={showCancelLastPayment}
                confirmCallback={() => cancelBatch()}
                title={"Cancel Batch"}
                description={`This is the last record in the batch.  Cancelling this record will cancel the batch.  Are you sure you want to cancel this record?`} />
            {hasBeenCanceledByUser !== null &&
                <Dialog
                    open={true}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title" style={{textAlign:"left"}}>Note</DialogTitle>
                    <DialogContent style={{textAlign:"left"}}>
                        <Grid container>
                            <Grid xs={1}>
                                <div style={{marginTop: "8px"}}>
                                    <InfoIcon color='primary' />
                                </div>
                            </Grid>
                            <Grid xs={9}>
                                <div><b>Batch Canceled</b></div>
                                <div>Batch {transactions.batchId} has been canceled by another user.</div>
                                <br />
                                <div>Please create a new batch for review and submit for processing.</div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setHasBeenCanceledByUser(null)}
                            color="primary"
                            variant='contained'
                            style={{margin: "auto", color: "white"}}
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            }
            {hasBeenCanceled &&
                <Dialog
                    open={true}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title" style={{textAlign:"left"}}>Note</DialogTitle>
                    <DialogContent style={{textAlign:"left"}}>
                        <Grid container>
                            <Grid xs={1}>
                                <div style={{marginTop: "8px"}}>
                                    <InfoIcon color='primary' />
                                </div>
                            </Grid>
                            <Grid xs={9}>
                                <div><b>Batch Expired</b></div>
                                <div>Batch {transactions.batchId} has expired due to inactivity.</div>
                                <br />
                                <div>Please create a new batch for review and submit for processing.</div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setHasBeenCanceled(false)}
                            color="primary"
                            variant='contained'
                            style={{margin: "auto", color: "white"}}
                        >
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            }
            <Grid style={{backgroundColor: "white", padding: "20px 0px 0px 0px"}}>
                <Grid container style={{ fontSize: "14px", margin: "0px 0px 0px 0px" }}>
                    <Grid item xs={2}>
                        <b>Batch ID: </b>{transactions?.batchId}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Run Date: </b>N/A
                    </Grid>
                    <Grid item xs={2}>
                        <b>Total Count: </b>{transactions?.count}
                    </Grid>
                    <Grid item xs={2}>
                        <b>Total Value: </b>{formatMoney(transactions?.totalAmount)}
                    </Grid>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={2}>
                        {downloading && <CircularProgress size={'1em'} style={{ marginRight: "5px" }} />}
                        <b>Download: </b><Link onClick={handleDownload} className="clickable">csv</Link>
                    </Grid>
                </Grid>
                <CustomTable
                    columns={[
                        { title: 'District', field: '', render: (rowData) => rowData?.districtName },
                        { title: 'Account', field: '', render: (rowData) => rowData?.billingAccount?.accountNumber },
                        { title: 'Name', field: '', render: (rowData) => rowData?.billingAccount?.customer?.fullName },
                        { title: 'Amount', field: '', render: (rowData) => formatMoney(rowData?.amount) },
                        { title: transactions?.batchType === "Chargeback" ? 'Dispute Case Date' : 'Return Date', field: '', render: (rowData) => dateToLocal(rowData.returnDate).toLocaleDateString() },
                        { title: transactions?.batchType === "Chargeback" ? 'Dispute Reason' : 'ACH Return Reason', field: '', render: (rowData) => rowData?.returnReason },
                        { title: 'Payment Status', field: '', render: (rowData) => rowData?.canceled ? "Canceled" : transactions?.batchType === "Chargeback" ? "Chargeback" : "ACH Return" },
                        { title: 'Payment Channel', field: '', render: () => "Returned Payment" },
                        { title: 'Error Reason', field: '', render: (rowData) => rowData?.errorReason }
                    ]}
                    pageSize={15}
                    enablePaging={false}
                    actions={[
                        {
                            icon: () => <CancelIcon htmlColor={"red"} />,
                            tooltip: "Remove From Batch",
                            onClick: (rowData: any, index: any) => {
                                checkLastPayment(rowData)
                            },
                            disabled: (rowData) => rowData?.canceled
                        }
                    ]}
                    dataEndpoint={(query) => {
                        return new Promise((resolve, reject) => {
                            ChargebacksService.chargebacksVGetBatch(transactions.id, query.pageNumber-1)
                            .then((x:any) => {
                                setTransactions(x)
                                resolve({
                                    items: x.chargebacks,
                                    numberOfItems: x.totalCount
                                })
                            })
                            .catch(x => reject(x))
                        })
                    }}
                    dataSet={null}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    title={""}
                    districtId={null}
                    addedQuery={null}
                    hiddenColumns={[]}
                    setHiddenColumns={null}
                    hiddenColumnsDisabled={true}
                    tableHeight={"400px"}
                    enableSearch={false}
                    searchPlaceholder={null} />

                {transactions.status === "Pending" &&
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "3px" }}>
                        <button disabled={transactions.canceled} onClick={() => setShowCancelBatch(true)} className='uvp-button gray-button'>Cancel Batch</button>
                        <button disabled={disablePayments || transactions.status === "Canceled"} onClick={() => setShowRunBatch(true)} className='uvp-button green-button'>Submit Batch</button>
                    </div>
                }
                {loading && 
                    <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                }
            </Grid>
        </React.Fragment>
    );
}